/*

? First, let's import the interface that will describe the shape of our chat object.

*/

import StateInterface from "../state-interface";

/*

& Now let's describe an initial state for the chat object. This is the state that will be used when the app first fires up. Think of it like a placeholder.

*/

export const broadcast: StateInterface["broadcast"] = {
	_id: "6310a47582b774b3ac71c5ad",
	broadcast_type: "property_offer",
	broadcast_mode: "private",
	property_id: "6310a47582b774b3ac71c5ad",
	requirement_id: "6310a47582b774b3ac71c5ad",
	chat_id: "6310a47582b774b3ac71c5ad",
	commission_offered: 0,
	notes: "",
	recipient_count: 0,
	status: "", // e.g., "delivered", "pending"
	delivered_at: new Date("2100-01-01T00:00:00.000Z"), // Placeholder date
	created_by: {
		is_business_profile: false,
		user_id: "6310a47582b774b3ac71c5ad",
		business_profile_id: "6310a47582b774b3ac71c5ad",
	},
	created_at: "",
	updated_at: "",
	is_edited: false,
	is_expired: false,
	expired_at: "",
	trigger_expired_at: "",
	is_deleted: false,
	deleted_at: "",
	source: {
		url: "",
		component: "",
	},
	assigned_to: [], // Array of ObjectIds for users or business profiles assigned to the broadcast
	open_to_negotiation: false,
};
